import { CheckCircle2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface GoalProgressRingProps {
  progress: number;
  size?: number;
  strokeWidth?: number;
  color?: string;
  completed?: boolean;
}

export function GoalProgressRing({
  progress,
  size = 60,
  strokeWidth = 6,
  color = 'hsl(var(--primary))',
  completed = false,
}: GoalProgressRingProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const strokeDashoffset = circumference - (Math.min(100, progress) / 100) * circumference;
  const center = size / 2;

  return (
    <div className="relative" style={{ width: size, height: size }}>
      <svg
        width={size}
        height={size}
        className="transform -rotate-90"
      >
        {/* Background circle */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          stroke="hsl(var(--muted))"
          strokeWidth={strokeWidth}
          fill="none"
        />
        {/* Progress circle */}
        <circle
          cx={center}
          cy={center}
          r={radius}
          stroke={completed ? 'hsl(142, 76%, 36%)' : color}
          strokeWidth={strokeWidth}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          className="transition-all duration-500 ease-out"
        />
      </svg>
      
      <div className="absolute inset-0 flex items-center justify-center">
        {completed ? (
          <CheckCircle2 className="h-5 w-5 text-green-500" />
        ) : (
          <span className={cn(
            "text-xs font-semibold",
            progress >= 100 ? "text-green-500" : "text-foreground"
          )}>
            {Math.round(progress)}%
          </span>
        )}
      </div>
    </div>
  );
}
